<fury-page-layout mode="card">
    <fury-page-layout-header>
      <fury-breadcrumbs [@fadeInRight]  current="Technicians"></fury-breadcrumbs>
    </fury-page-layout-header>
    
    <fury-page-layout-content [@fadeInUp]>
      <div class="tab_section">
        <fury-list name={{filterValue}} [hideSearchInput]="true" [columns]="columns">
        <mat-tab-group animationDuration="0ms"  [selectedIndex]="selectedTabIndex" (selectedTabChange)="tabChangeHandle($event)">
          <mat-tab label="Pending">
            <fury-technician-table
              [itemList]="itemList"
              [dataSource]="dataSource"
              [columns]="columns"
              [searchForm]="searchForm"
              [isLoading]="isLoading"
              (fetchTechnician)="handleFetchTechnician($event)"
              (search)="handleSearch($event)"
            ></fury-technician-table>
            <mat-paginator class="pegig" [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize" [length]="totalCount" [pageIndex]="pageIndex" (page)="pageSizeChange($event)"
                showFirstLastButtons
                [selectConfig] = "selectConfig"
                [ngClass]="{'mat-pegig': pageSize === 9999}"
                aria-label="Select page of periodic elements">
            </mat-paginator>
         
          </mat-tab>
          <mat-tab label="Approved">
            <fury-technician-table
              [itemList]="itemList"
              [dataSource]="dataSource"
              [columns]="columns"
              [searchForm]="searchForm"
              [isLoading]="isLoading"
              (fetchTechnician)="handleFetchTechnician($event)"
              (search)="handleSearch($event)"
            ></fury-technician-table>
            <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize" [length]="totalCount" [pageIndex]="pageIndex" (page)="pageSizeChange($event)"
                showFirstLastButtons
                [selectConfig] = "selectConfig"
                [ngClass]="{'mat-pegig': pageSize === 9999}"
                aria-label="Select page of periodic elements">
            </mat-paginator>
          </mat-tab>
          <mat-tab label="Declined">
            <fury-technician-table
              [itemList]="itemList"
              [dataSource]="dataSource"
              [columns]="columns"
              [searchForm]="searchForm"
              [isLoading]="isLoading"
              (fetchTechnician)="handleFetchTechnician($event)"
              (search)="handleSearch($event)"
            ></fury-technician-table>
            <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize" [length]="totalCount" [pageIndex]="pageIndex" (page)="pageSizeChange($event)"
                showFirstLastButtons
                [selectConfig] = "selectConfig"
                [ngClass]="{'mat-pegig': pageSize === 9999}"
                aria-label="Select page of periodic elements">
            </mat-paginator>
          </mat-tab>
        </mat-tab-group>
        </fury-list>
      </div>
      
  
    </fury-page-layout-content>
</fury-page-layout>
  
